import { disclaimerList } from "@/mocks/homeMocks";

export default function Disclaimer() {
  return (
    <section id="note" className="w-full border-y border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.4fr] md:gap-12">
          {/* 左侧说明 */}
          <div>
            <p className="flex items-center gap-2 text-xs tracking-[0.28em] text-foreground-500">
              <span className="inline-block h-px w-8 bg-primary-400"></span>
              扒哥 · 编辑声明
            </p>
            <h2 className="font-heading mt-3 text-2xl md:text-3xl font-black leading-snug tracking-tight text-foreground-950">
              锤得明白，也澄清得了
            </h2>
            <p className="mt-4 text-sm md:text-base leading-7 text-foreground-600">
              我们把「实锤」当成一道需要留证的工序来做：给来源、给时间、给推理过程，也给你的质疑留位置。证据不足的案子，我们宁可写「待定性」，也不补戏。
            </p>
            <div className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100">
              <i className="ri-refund-2-line text-base" aria-hidden="true"></i>
              凭有效凭证申请勘误
            </div>
          </div>

          {/* 右侧条目 */}
          <ul className="flex flex-col gap-3">
            {disclaimerList.map((d) => (
              <li
                key={d}
                className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-100/50 p-4"
              >
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50">
                  <i className="ri-check-line text-xs" aria-hidden="true"></i>
                </span>
                <span className="text-sm leading-6 text-foreground-600">{d}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}